import { numberToPrettyString } from '@cian/utils';

import {
  ECurrency,
  IPriceForMobileSite,
} from '../../../../repositories/dailyrent/entities/price_for_mobile_site/PriceForMobileSite';

export const currencyToString = (currency: ECurrency) => {
  switch (currency) {
    case ECurrency.Eur:
      return '€';
    case ECurrency.Usd:
      return '$';
    case ECurrency.Rur:
    default:
      return '₽';
  }
};

export const formatPrice = (price: IPriceForMobileSite) => {
  const number = numberToPrettyString(price.value);
  const currency = currencyToString(price.currency);

  return `${number} ${currency}/сут.`;
};
